import merge from "lodash-es/merge";
import omitBy from "lodash-es/omitBy";
import pick from "lodash-es/pick";

export const PERMISSION_GRANT_KEYS = [
  "executivesummary",
  "sparxscatalog",
  "channeldetail",
  "sparxseditor",
  "svgalteration",
] as const;

export type PermissionGrantKey = (typeof PERMISSION_GRANT_KEYS)[number];

export type PermissionGrants = Record<PermissionGrantKey, boolean>;

const permissionGrantPickPaths = [...PERMISSION_GRANT_KEYS] as const;

export const applyPermissionGrantsPatch = (
  base: PermissionGrants,
  patch: Partial<PermissionGrants>,
): PermissionGrants => {
  const picked = pick(patch, permissionGrantPickPaths);
  const definedOnly = omitBy(
    picked,
    (value) => value === undefined,
  ) as Partial<PermissionGrants>;
  return merge({}, base, definedOnly);
};

export const createEmptyPermissionGrants = (): PermissionGrants => ({
  executivesummary: false,
  sparxscatalog: false,
  channeldetail: false,
  sparxseditor: false,
  svgalteration: false,
});
